
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.972 8.5a15.447 15.447 0 00-10.68 4.293l-2.231-2.232c-.945-.945-2.561-.276-2.561 1.06V20a1.5 1.5 0 001.5 1.5h8.379c1.336 0 2.005-1.616 1.06-2.56l-2.609-2.61a10.424 10.424 0 017.077-2.83c5.775-.05 10.643 4.624 10.593 10.59-.048 5.66-4.637 10.41-10.5 10.41-2.57 0-5-.917-6.914-2.597a.749.749 0 00-1.023.034l-2.48 2.48a.752.752 0 00.03 1.089A15.443 15.443 0 0024 39.5c8.56 0 15.5-6.94 15.5-15.5 0-8.55-6.978-15.515-15.528-15.5z","fill":"#535353"}})])
          )
        }
      }
    